import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environment';
import { Observable } from 'rxjs';

// TODO: prime candidate for shared code in a lib repo somewhere

export abstract class ApiServiceBase {
	protected abstract basePath: string;

	constructor(private _http: HttpClient) { }

	protected get<T>(path: string, data: any): Observable<T> {
		const url = this.buildUrl(path);
		const options: {
			observe?: 'body',
			responseType?: 'json'
		} = this.buildRequestParams(data);

		return this._http.get<T>(url, options);
	}

	protected post<T>(path: string, data: any): Observable<T> {
		const url = this.buildUrl(path);

		return this._http.post<T>(url, data);
	}

	protected put<T>(path: string, data: any): Observable<T> {
		const url = this.buildUrl(path);

		return this._http.put<T>(url, data);
	}

	// #region Internal

	private buildUrl(path: string): string {
		return `${environment.backendUrl}/${this.basePath}/${path}`;
	}

	private buildRequestParams(data: any): any {
		let params = new HttpParams();

		if (!data) { return params; }

		for (const key of Object.keys(data)) {
			// skip parameter if value is undefined or null
			if ((data[key] === undefined) || (data[key] === null)) {
				continue;
			}

			params = params.set(key, data[key]);
		}

		return { params: params, observe: 'body' };
	}

	// #endregion
}
